import script from "./RedesignEventNotification.vue?vue&type=script&setup=true&lang=js"
export * from "./RedesignEventNotification.vue?vue&type=script&setup=true&lang=js"

import "./RedesignEventNotification.vue?vue&type=style&index=0&id=c0872000&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c0872000"]])

export default __exports__